export const REQUEST_FAILED = "REQUEST_FAILED";
export const TRANSACTION_FAILED = "TRANSACTION_FAILED";
export const TRANSACTION_STARTED = "TRANSACTION_STARTED";
export const TRANSACTION_PENDING = "TRANSACTION_PENDING";
export const TRANSACTION_SUCCEEDED = "TRANSACTION_SUCCEEDED";

export function setTransactionPending(requestType, args) {
  return {
    type: TRANSACTION_PENDING,
    requestType,
    args
  };
}

export function startTransaction(requestType, jqXHR) {
  return {
    type: TRANSACTION_STARTED,
    requestType,
    jqXHR
  };
}

export function setTransactionSuccessful(requestType) {
  return {
    type: TRANSACTION_SUCCEEDED,
    requestType
  };
}

export function failRequest(requestType) {
  return {
    type: REQUEST_FAILED,
    requestType
  };
}

export function failTransaction(requestType) {
  return {
    type: TRANSACTION_FAILED,
    requestType
  };
}
